<template>
  <div class="accountProtect">
    <div class="clear">
      <h2 class="paging-title">账户安全</h2>
    </div>
    <div class="account-protect-box">
      <div>
        <!-- 登录密码 -->
        <div class="item-account">
          <span class="el-icon-success icon-ok"></span>
          <h2 class="item-title">登录密码</h2>
          <p class="item-tips">
            <i>互联网账号存在被盗风险，建议您定期更改密码以保护账号安全。</i>
          </p>
          <button class="submit" @click="isShowDialog1 = true">修改</button>
        </div>
        <!-- 手机绑定 -->
        <div class="item-account">
          <span class="el-icon-success icon-ok"></span>
          <h2 class="item-title">手机绑定</h2>
          <p class="item-tips">
            您已绑定手机{{accountInfo.Handset}}，若已丢失或停用，请立即更换，避免<i>账户被盗</i>。
          </p>
          <button class="submit" @click="isShowDialog2 = true">更换</button>
        </div>
        <!-- 支付密码 -->
        <div class="item-account">
          <span class="el-icon-success icon-ok" v-if="accountInfo.IsSetPayPwd"></span>
          <span class="el-icon-warning icon-tip" v-else></span>
          <h2 class="item-title">支付密码</h2>
          <p class="item-tips">用于支付工单服务费和体现，请谨慎保管。</p>
          <button class="submit" @click="isShowDialog3 = true">{{accountInfo.IsSetPayPwd?'修改':'设置密码'}}</button>
        </div>
        <!--  个人账户才会有  -->
        <!-- 微信绑定 -->
        <div class="item-account" v-if="userInfo.LoginAccountType==1">
          <span class="el-icon-success icon-ok" v-if="accountInfo.IsBindWeiXin"></span>
          <span class="el-icon-warning icon-tip" v-else></span>
          <h2 class="item-title">微信绑定</h2>
          <p class="item-tips" v-if="accountInfo.IsBindWeiXin">
            您已绑定微信,若已丢失或停用，请立即解绑，避免<i>账户被盗</i>。
          </p>
          <p class="item-tips" v-else>暂无绑定</p>
          <button class="submit" v-if="accountInfo.IsBindWeiXin">解除绑定</button>
        </div>
        <!-- QQ绑定 -->
        <div class="item-account" v-if="userInfo.LoginAccountType==1">
          <span class="el-icon-success icon-ok" v-if="accountInfo.IsBindQQ"></span>
          <span class="el-icon-warning icon-tip" v-else></span>
          <h2 class="item-title">QQ绑定</h2>
          <p class="item-tips"  v-if="accountInfo.IsBindQQ">您已绑定QQ,若已丢失或停用，请立即解绑，避免<i>账户被盗</i>。</p>
          <p class="item-tips" v-else>暂无绑定</p>
					<button class="submit" v-if="accountInfo.IsBindQQ">解除绑定</button>
        </div>
      </div>
    </div>
    <my-dialog
      :show="isShowDialog1"
      width="600px"
      title="修改登录密码"
      @close="closeDialog"
		class="password"
    >
      <div v-if="!isValid">
        <!-- :model="form" -->
        <el-form ref="validForm" label-width="90px" style="padding: 30px;" :model="validForm" :rules="validRule">
          <el-form-item label="手机号：" prop="phone" >
            <el-input size="medium" placeholder="请输入绑定手机号码" disabled v-model="validForm.phone"></el-input>
          </el-form-item>
			<div id="captchaEdit"></div>
          <el-form-item label="验证码：" prop="code">
            <div style="display: flex;align-items: center;">
              <el-input size="medium" placeholder="请输入验证码" v-model="validForm.code"></el-input>
              <button
                style="flex: 0 0 40%;height: 36px;color: #666;font-size: 14px;"
								@click="getCode"
								:disabled="btnDisabled"
              >
                {{codeBtnText}}
              </button>
            </div>
          </el-form-item>
          <p class="tip">如有任何问题请拨打客服电话：021-60956592</p>
        </el-form>
        <div>
          <button class="submit-reset-pwd" @click="validPhone">确定</button>
        </div>
      </div>
      <div v-if="isValid">
        <el-form ref="loginForm" label-width="90px" style="padding: 30px;" :model="loginForm" :rules="loginRule">
          <el-form-item label="新密码：" prop="password">
            <el-input
              size="medium"
              show-password
              maxlength="20"
							v-model.trim="loginForm.password"
              placeholder="请输入6-20位新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认："  prop="password2">
            <el-input
              size="medium"
              show-password
              maxlength="20"
							v-model.trim="loginForm.password2"
              placeholder="请再次输入密码"
            ></el-input>
          </el-form-item>
          <p class="tip">如有任何问题请拨打客服电话：021-60956592</p>
        </el-form>
        <div>
          <button class="submit-reset-pwd" @click="confirmReset">确定</button>
        </div>
      </div>
    </my-dialog>

    <my-dialog
      :show="isShowDialog2"
      width="600px"
      title="修改绑定手机"
      @close="closeDialog"
    >
      <div>
        <!-- :model="form" -->
        <el-form ref="bindForm" label-width="90px" style="padding: 30px;" :model="bindForm" :rules="bindRule">
          <el-form-item label="新手机号：" prop="phone">
            <el-input size="medium" placeholder="请输入绑定手机号码" v-model="bindForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <div style="display: flex;align-items: center;">
              <el-input size="medium" placeholder="请输入验证码" v-model="bindForm.code"></el-input>
              <button
                style="flex: 0 0 40%;height: 36px;color: #666;font-size: 14px;"
								@click="getCode2"
								:disabled="btnDisabled"
              >
                {{codeBtnText}}
              </button>
            </div>
          </el-form-item>
          <p class="tip">如有任何问题请拨打客服电话：021-60956592</p>
        </el-form>
        <div>
          <button class="submit-reset-pwd" @click="bindPhone">确定</button>
        </div>
      </div>
    </my-dialog>

    <my-dialog
      :show="isShowDialog3"
      width="600px"
      title="修改支付密码"
      @close="isShowDialog3 = false"
    >
      <el-form ref="payForm" label-width="90px" style="padding: 30px;" :model="payForm" :rules="payRule">
          <el-form-item label="支付密码：" prop="password">
            <el-input
              size="medium"
              show-password
              maxlength="6"
							v-model="payForm.password"
              placeholder="请输入6位数字支付密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认："  prop="password2">
            <el-input
              size="medium"
              show-password
              maxlength="6"
							v-model="payForm.password2"
              placeholder="请再次输入6位数字支付密码"
            ></el-input>
          </el-form-item>
          <p class="tip">如有任何问题请拨打客服电话：021-60956592</p>
        </el-form>
        <div>
          <button class="submit-reset-pwd" @click="resetPayPassword">确定</button>
        </div>
    </my-dialog>
  </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import {aesEncrypt} from '@/scripts/aesHelper.js'
import validate from '@/scripts/validate.js'
import { 
	UpdatePayPwd,
	UpdateBindPhoneNumber,
	ResetPwd,
	SendValidCode,
	CheckValidCode,
	GetAccountSecurityInfo,

	SendMobileCode,			//新获取验证码
} from '@/scripts/api.js'
import { mapState } from 'vuex';
let _dx=window._dx;
export default {
  components: {
    "my-dialog": Dialog,
  },
  data() {
		//校验手机号
		var validatePhone = (rule, value, callback) => {
			if (!validate.phone(value)) {
				callback(new Error('手机号格式不正确'));
			}  else {
				callback();
			}
		};
		//校验登录密码
		var validateLoginPass = (rule, value, callback) => {
			if (!validate.password(value)) {
				callback(new Error('密码必须是6-20位数字和字母!'));
			}  else {
				callback();
			}
		};
		//校验登录密码2
		var validateLoginPass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.loginForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		//校验支付密码
		var validatePayPass = (rule, value, callback) => {
			if (!/^\d{6}$/.test(value)) {
				callback(new Error('密码必须是6位数字!'));
			}  else {
				callback();
			}
		};
		//校验支付密码2
		var validatePayPass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.payForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
    return {
			accountInfo:{
				IsSetPayPwd:0,
				IsBindQQ:0,
				Handset:0,
				IsBindWeiXin:0,
			},
      isShowDialog1: false,
			isValid:false,//是否通过验证
      isShowDialog2: false,
      isShowDialog3: false,
			code:'',
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
			validForm:{
				phone:'',
				code:'',
			},
			loginForm:{
				password:'',
				password2:'',
			},
			bindForm:{
				phone:'',
				code:'',
			},
			payForm:{
				password:'',
				password2:'',
			},
			validRule:{
				code:[{require:true,message: '请输入验证码',trigger: 'blur'}],
			},
			bindRule:{
				phone:[{require:true,message: '请输入手机号',trigger: 'blur'},{validator: validatePhone,trigger: 'blur'}],
				code:[{require:true,message: '请输入验证码',trigger: 'blur'}],
			},
			loginRule:{
				password:[{require:true,message: '请输入登录密码',trigger: 'blur'},{validator: validateLoginPass,trigger: 'blur'}],
				password2:[{validator: validateLoginPass2,trigger: 'blur'}]
			},
			payRule:{
				password:[{require:true,message: '请输入支付密码',trigger: 'blur'},{validator: validatePayPass,trigger: 'blur'}],
				password2:[{validator: validatePayPass2,trigger: 'blur'}]
			}
    };
  },
	computed:{
		...mapState({
			userInfo:state=>state.userInfo,
		}),
		isHome(){
			return this.$route.path=='/home'
		}
	},
	created() {
		this.getAccountInfo();
	},
  methods: {
		//获取用户账号绑定数据
		getAccountInfo(){
					let params={};
					if(this.userInfo && this.userInfo.UserId){
						params['userId']=this.userInfo.UserId;
					}
					if(this.userInfo && this.userInfo.CompanyId){
						params['companyId']=this.userInfo.CompanyId;
					}
			GetAccountSecurityInfo(params).then(r=>{
				if(r.Result==1){
					let data=r.Data||{};
					this.accountInfo={
						...data,
					}
					this.validForm.phone=this.accountInfo.Handset;
				}else{
					this.$toast(r.Message);
				}
			})
		},
		//获取验证码_修改登录密码
		// getCode(){
		// 	this.sendCode(this.validForm.phone,1);
		// },
		getCode(){
			// this.sendCode(this.validForm.phone,1);
			var that = this;
			this.myCaptcha = _dx.Captcha(document.getElementById('captchaEdit'), {
				appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
				style: 'inline',
				width: 410,
				success: function (token) {
					SendMobileCode({
						phone: that.validForm.phone,
						codeType: 1,
						imgCodeToken:token,
						platform:'pcweb'
						}).then(r => {
						// myCaptcha.hide();
						if (r.Result == 1) {
							let time = 120;
							that.btnDisabled = true;
							that.timer = setInterval(() => {
								time--;
								that.codeBtnText = time + "s";
								if (time <= 0) {
								time = 120;
								that.btnDisabled = false;
								that.codeBtnText = "获取验证码";
								clearInterval(that.timer);
								}
							}, 1000);
							that.$toast(r.Message);
						} else {
							that.$toast(r.Message);
						}
					});
				},
				fail:function(err){
					console.log(err)
				}
			})
			this.myCaptcha.show();
			// this.myCaptcha.reload()
			return false
		},
		//获取验证码_绑定手机
		getCode2(){
			this.sendCode(this.bindForm.phone,2);
		},
		//发送验证码
		sendCode(phone,type){
			SendValidCode({
        phone:phone,
        codeType:type,
      }).then(r => {
        if (r.Result == 1) {
          let time = 120;
          this.btnDisabled = true;
          this.timer = setInterval(() => {
            time--;
            this.codeBtnText = time + "s";
            if (time <= 0) {
              time = 120;
              this.btnDisabled = false;
              this.codeBtnText = "获取验证码";
              clearInterval(this.timer);
            }
          }, 1000);
          this.$toast(r.Message);
        } else {
          this.$toast(r.Message);
        }
      });
		},
		//验证手机号
		validPhone(){
			this.$refs.validForm.validate(valid=>{
				if(valid){
					CheckValidCode({
						CodeType:1,
						ValidateCode:this.validForm.code,
						Phone:this.validForm.phone
					}).then(r=>{
						if(r.Result==1){
							this.isValid=true;
							this.validForm.code='';
							this.btnDisabled = false;
							this.codeBtnText = "获取验证码";
							clearInterval(this.timer);
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		},
		//确认修改登录密码
		confirmReset(){
			this.$refs.loginForm.validate(valid=>{
				if(valid){
					ResetPwd({
						ValidCodePhoneNumber:this.userInfo.Handset,
						UserCode:this.userInfo.UserCode,
						Password:this.loginForm.password,
					}).then(r=>{
						if(r.Result==1){
							this.$toast('修改成功');
							this.$refs.loginForm.resetFields();
							this.isValid=false;
							this.isShowDialog1=false;
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		},
		//关闭弹框并清除定时器
		closeDialog(){
			this.isShowDialog1=false;
			this.isShowDialog2=false;
			this.btnDisabled = false;
			this.codeBtnText = "获取验证码";
			clearInterval(this.timer);
		},
		//修改绑定的手机号
		bindPhone(){
			this.$refs.bindForm.validate(valid=>{
				if(valid){
					UpdateBindPhoneNumber({
						PhoneNumber:this.bindForm.phone,
						UserCode:this.userInfo.UserCode,
						ValidateCode:this.bindForm.code,
					}).then(r=>{
						if(r.Result==1){
							this.$toast('修改成功');
							this.isShowDialog2=false;
							this.$refs.bindForm.resetFields();
							this.btnDisabled = false;
							this.codeBtnText = "获取验证码";
							clearInterval(this.timer);
							this.getAccountInfo();
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		},
		//修改支付密码
		resetPayPassword(){
			this.$refs.payForm.validate(valid=>{
				if(valid){
					console.log(this.payForm.password)
					let params={
						payPwd:aesEncrypt(this.payForm.password,2)
					};
					if(this.userInfo && this.userInfo.UserId){
						params['userId']=this.userInfo.UserId;
					}
					if(this.userInfo && this.userInfo.CompanyId){
						params['companyId']=this.userInfo.CompanyId;
					}
					UpdatePayPwd(params).then(r=>{
						if(r.Result==1){
							this.$alert('恭喜您，已重置支付密码！').then(r=>{
								this.isShowDialog3=false;
							})
						}else{
							this.$toast(r.Message);
						}
					})
				}
			})
		}
	},
};
</script>
<style lang="scss">
.accountProtect{
	.account-protect-box {
		margin-top: 30px;
		background: #f9f9f9;
		padding: 30px 20px;
		.item-account {
			border-bottom: 1px solid #e5e5e5;
			min-height: 115px;
			display: flex;
			align-items: center;
			padding: 0 40px;
			.icon-ok {
				width: 48px;
				height: 48px;
				margin-right: 30px;
				font-size: 48px;
				color: green;
			}
			.icon-tip {
				width: 48px;
				height: 48px;
				margin-right: 30px;
				font-size: 48px;
				color: orange;
			}
			.item-title {
				font-size: 16px;
				color: #333;
				font-weight: 600;
				margin-top: 0;
				margin-bottom: 0;
				margin-right: 50px;
			}
			.item-tips {
				font-size: 14px;
				color: #999;
				i {
					color: #f75959;
				}
			}
			.submit {
				margin-left: auto;
				width: 80px;
				height: 24px;
				line-height: 22px;
				border-radius: 2px;
				background: #00a0e9;
				color: #fff;
				font-size: 12px;
				text-align: center;
				border: none;
				cursor: pointer;
			}
		}
	}
	.submit-reset-pwd {
		display: block;
		width: 100px;
		height: 32px;
		background: #f75959;
		color: #fff;
		line-height: 32px;
		text-align: center;
		font-size: 14px;
		border: none;
		border-radius: 2px;
		margin: 0 auto;
		cursor: pointer;
	}
	.tip{
		font-size: 14px;
		color: #f75959;
		line-height: 24px;
		padding-left: 90px;
	}
}
.password {
	.dialog-container {
		overflow: visible;
	}
	.dialog-head {
		z-index: 0;
	}
	#captchaEdit{
		margin-bottom: 22px;
		margin-left: 90px;
		opacity: 1 !important;
		.dx_captcha_basic_link img {
			display: none;
		}
	}
}
</style>
